const contentful = require('contentful')
const config = {
  space: process.env.REACT_APP_CONTENTFUL_SPACE_ID,
  accessToken: process.env.REACT_APP_CONTENTFUL_DELIVERY_TOKEN,
  include: 2,
};

export function createClient() {
  return contentful.createClient(config);
}